import { render, staticRenderFns } from "./FinanceSidebarMenu.vue?vue&type=template&id=22feeba1"
import script from "./financeSidebarMenu.ts?vue&type=script&lang=ts&external"
export * from "./financeSidebarMenu.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports